import { Button, Form, Input, Select } from 'antd';
import React, { useEffect } from 'react';
import { useTeams } from './TeamStore';
import { useForm } from 'antd/es/form/Form';

function Edit() {
    let { ed, editTeam } = useTeams()
    let [form] = useForm()
    useEffect(() => {
        form.setFieldsValue(ed)
    }, [ed, form])
    return (
        <Form form={form} layout='vertical' onFinish={(v) => editTeam(v)}>
            <Form.Item name={'id'} hidden>
                <Input />
            </Form.Item>
            <Form.Item name={'name'} label="To'liq ism sharif" rules={[{ required: true, message: 'Iltimos ismingizni kiriting!' }]}>
                <Input />
            </Form.Item>
            <Form.Item name={'role_id'} label="Mansabi" rules={[{ required: true, message: 'Iltimos mansabni tanlang!' }]}>
                <Select
                    options={[
                        {
                            label: 'Admin',
                            value: 1
                        },
                        {
                            label: 'Buxgalter',
                            value: 2
                        },
                        {
                            label: 'Sotuvchi',
                            value: 3
                        },
                        {
                            label: 'Sklad',
                            value: 4
                        },
                    ]}
                />
            </Form.Item>
            <Form.Item name={'email'} label="Email yoki login" rules={[{ required: true, message: 'Iltimos email yoki login kiriting!' }]}>
                <Input />
            </Form.Item>
            <Form.Item name={'pass'} label="Parol" rules={[{ required: true, message: 'Iltimos parol kiriting!' }]}>
                <Input type="password" />
            </Form.Item>
            <Form.Item>
                <Button type="primary" htmlType="submit">Qo'shish</Button>
            </Form.Item>
        </Form>
    );
}

export default Edit;